import React from "react";
import { LegacyCard as Card, InlineStack, Text, Pagination, Select } from "@shopify/polaris";
import propType from "prop-types";

const SessionFooter = (props) => {
  const { optionList, count, perPageCount, onSelectLimit, onPerPage, currentPage } = props;
  const totalCountLabel = "Total Count :";
  return (
    <>
      <Card.Section>
        <InlineStack>
          <Text as="span" variant="bodySm">
            <b>{totalCountLabel}</b>
            {` ${count}`}
          </Text>
          <Pagination
            hasPrevious={(count && currentPage !== 1 && true) || false}
            onPrevious={() => {
              if (currentPage !== 1) {
                onPerPage(currentPage - 1);
              }
            }}
            hasNext={(currentPage < count && true) || false}
            onNext={() => {
              if (currentPage <= count) {
                onPerPage(currentPage + 1);
              }
            }}
          />
          <Select value={perPageCount} options={optionList} onChange={onSelectLimit} />
        </InlineStack>
      </Card.Section>
    </>
  );
};

SessionFooter.propTypes = propType.type;
SessionFooter.defaultProps = propType.default;
export default SessionFooter;
